/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateTenantRestrictionsOptions,
  CreateTenantRestrictionsResponses,
} from '../types/CreateTenantRestrictions'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Add restrictions for tenant.
 * {@link /v1/tenants/:tenant_id/restrictions}
 */
export function createTenantRestrictions<ThrowOnError extends boolean = true>(
  options: Options<CreateTenantRestrictionsOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateTenantRestrictionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/tenants/{tenant_id}/restrictions',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateTenantRestrictionsResponses, ThrowOnError>>,
  )
}
